import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai/index';
import styles from './css/index.module.scss';
import Button from '../../../../ui-kit/Button';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import MySlider from '../../../../components/MySlider';
import Slider1Image from '../../../../assets/images/mainSlider/1.PNG';
import Slider2Image from '../../../../assets/images/mainSlider/2.PNG';
import Slider3Image from '../../../../assets/images/mainSlider/3.PNG';
import Slider4Image from '../../../../assets/images/mainSlider/4.PNG';
import Slider5Image from '../../../../assets/images/mainSlider/5.PNG';
import BuildingImage from '../../../../assets/images/Building.png';
import { resourcePathAtom, siteModulesAtom, windowWidthAtom } from '../../../../atoms/globalAtoms';

function WhatIs() {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const [windowWidth] = useAtom(windowWidthAtom);
  const [siteModules] = useAtom(siteModulesAtom);
  const [resourcePath] = useAtom(resourcePathAtom);

  const aboutModule = useMemo(() => siteModules?.find((i) => i.module_name === 'about'), [siteModules]);
  const sliderImages = useMemo(() => {
    if (!aboutModule?.meta?.slider1 || !resourcePath) return [];

    return aboutModule.meta.slider1.reduce((acc, i) => [...acc, resourcePath + i], []);
  }, [aboutModule, resourcePath]);

  const onAboutClick = () => {
    navigate('/about');
  };

  return (
    <section className={styles.whatIs}>
      <div className={classNames('container')}>
        <div className={styles.whatIsInner}>
          <p className={classNames(styles.mainTitle, styles.mobileTitle)}>
            {aboutModule?.name || t(DICTIONARY.whatIsTitle)}
          </p>

          <div className={styles.whatIsLeft}>
            <MySlider
              objectFit="contain"
              frameHeight={windowWidth <= 900 ? 300 : 414}
              images={sliderImages}
            />
          </div>

          <div className={styles.whatIsRight}>
            <p className={classNames(styles.mainTitle, styles.desktopTitle)}>
              {aboutModule?.name || t(DICTIONARY.whatIsTitle)}
            </p>

            {aboutModule?.content ? (
              <p className={styles.description} dangerouslySetInnerHTML={{ __html: aboutModule.content }} />
            ) : (
              <p className={styles.description}>
                {t(DICTIONARY.whatIsDescription1)}
                <br />
                <br />
                {t(DICTIONARY.whatIsDescription2)}
                <br />
                <br />
                {t(DICTIONARY.whatIsDescription3)}
              </p>
            )}

            <div className={styles.buttonWrapper}>
              <Button
                text={t(DICTIONARY.moreAboutConfiguratorButton)}
                onClick={onAboutClick}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhatIs;
